import core from './core';

export function getPartnerStats(dateFrom: string, dateTo: string) {
  return core.get(`api/2/account/partner?startDate=${dateFrom}&endDate=${dateTo}`).then(({data}) => data);
}
